module.exports = __webpack_public_path__ + "static/media/menu.bb4452c9.svg";